<template>
  <div>
    <div class="form-group-style">
      <el-form
        class="form-container"
        :model="info"
        ref="addZhuantiForm"
        :rules="zhuantiRules"
      >
        <div class="form-item bidding-tips">
          <div class="form-label">
            <span class="label">注意事项：</span>
          </div>
          <div class="form-input-item">
            <el-form-item>
              <p>
                1.请大家做专题一定要加title、keywords和descreption。关键词最好在3个以内，最多也不要超过5个，标题可重复关键词，不要超过3次，描述要求通顺并且自然的展现出关键词要求通顺并且自然的展现出关键词。
              </p>
              <p>
                2.页面里的图片要加alt，就是悬浮在图片上，要显示关键词，写法alt=“关键词：图片说明”。
              </p>
              <p>3.适当在页面重复关键词，增加关键词的密度。</p>
              <p>4.专题完成后第一时间将正式页面链接提交到百度的提交地址。</p>
              <p>5..定期更新内容，做好内链与外链策略，引导蜘蛛爬取。</p>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">站点</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="site_id">
              <site-auto-complete
                v-model="info.site_id"
                :clueId="1"
                :init-choose-first="false"
                :owned="true"
                ref="siteAutoComplete"
                clearable
              ></site-auto-complete>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">链接类型</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="link_type">
              <el-select class="input-control" v-model="info.link_type" :disabled="info.url!= ''">
                <el-option value="0" label="PC端链接"></el-option>
                <el-option value="1" label="M端链接"></el-option>
                <el-option value="2" label="专题自适应（PC+M）"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">专题标题：</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="name">
              <el-input
                placeholder="请输入标题"
                class="input-control"
                v-model="info.name"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">描述</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="description">
              <el-input
                type="textarea"
                placeholder="要求一段完整的话，可包含关键词。"
                class="input-control"
                v-model="info.description"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">关键词</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="keywords">
              <el-tag
                class="topic-tag"
                v-model="ztTags"
                v-for="(tag,index) in ztTags"
                :key="index"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
                >{{ tag }}</el-tag
              >
              <template v-if="ztTags.length < 5">
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="small"
                  max-length="10"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                ></el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput"
                  >+ 添加关键字</el-button
                >
              </template>
            </el-form-item>
          </div>
        </div>
        <div class="form-item" style="height: 152px">
          <div class="form-label">
            <span class="label">专题文件</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="url">
              <div class="huxing-input">
                <div
                  class="upload-group clearfix"
                  v-if="info.url && info.url !== ''"
                >
                  <div class="upload-item">
                    <img :src="zipUrl" alt />
                    <div class="shadow">
                      <i class="el-icon-delete" @click="clearUploadZt"></i>
                    </div>
                  </div>
                </div>
                <div class="upload-group-2" v-else>
                  <i class="el-icon-plus"></i>
                  <input
                    type="file"
                    class="type-file"
                    accept="zip"
                    @change="checkZtFile($event)"
                    id="pictureUploadZt"
                  />
                </div>
                <p class="tip">
                  仅可上传10M以内 .zip格式的压缩文件！要求专题文件内单张图片文件不超过1M；index.html 文件放置于专题文件夹根目录下；专题文件夹与压缩文件的名称保持一致。
                </p>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="form-item" style="height: 152px" v-if="showShare">
          <div class="form-label">
            <span class="label">分享缩略图</span>
          </div>
          <div class="form-input-item">
            <el-form-item>
              <div class="huxing-input">
                <div
                  class="upload-group clearfix"
                  v-if="info.full_img && info.full_img !== ''"
                >
                  <div class="upload-item">
                    <img :src="info.full_img" alt />
                    <div class="shadow">
                      <i class="el-icon-delete" @click="clearUpload"></i>
                    </div>
                  </div>
                </div>
                <div class="upload-group-2" v-else>
                  <i class="el-icon-plus"></i>
                  <input
                    type="file"
                    class="type-file"
                    accept="*"
                    @change="checkFile($event)"
                    id="pictureUploadFile"
                  />
                </div>
                <p class="tip">用于分享到微信等平台时的缩略图显示。</p>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="form-item" v-if="info.link_type != 2 ">
          <div class="form-label">
            <span class="label">映射链接：</span>
          </div>
          <div class="form-input-item">
            <el-form-item prop="mapping_link">
              <el-input
                placeholder="若当前生成PC端链接，输入M端链接，提交后在M端打开PC端链接会自适应成M端链接"
                class="input-control"
                v-model="info.mapping_link"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-button">
          <el-button type="primary" @click="submitForm('addZhuantiForm')"
            >生 成</el-button
          >
          <el-button type="info" plain @click="toList()">取 消</el-button>
        </div>
      </el-form>
    </div>
    <div
      class="topic-loading"
      v-loading="loading"
      element-loading-text="专题上传中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></div>
  </div>
</template>
<script>
import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
import { UPLOAD_CODE } from "@/config/index";
import { validateEmpty } from "@/utils/validate";
import { uploadFile } from "@/service/wikipedia";
import { uploadZhuantiFile, addTopics } from "@/service/zhuanti";
export default {
  name: "List",
  components: {
    SiteAutoComplete,
  },
  data() {
    return {
      loading: false,
      zipUrl: "",
      info: {
        site_id: "",
        img: "",
        full_img: "",
        url: "",
        dir: "",
        link_type: "0",
        name: "",
        description: "",
        keywords: "",
        mapping_link: "",
      },
      ztTags: [],
      showShare:false,
      inputVisible: false,
      inputValue: "",
      zhuantiRules: {
        site_id: [{ required: true, message: "请选择站点", trigger: "change" }],
        name: [
          { validator: validateEmpty, result: "专题标题", trigger: "blur" },
          { min: 1, max: 50, message: "长度1到50个字符" },
        ],
        description: [
          { validator: validateEmpty, result: "描述", trigger: "blur" },
          { min: 1, max: 300, message: "长度1到300个字符" },
        ],
        keywords: [{ required: true, message: "请至少添加一个关键字" }],
        url: [{ required: true, message: "请上传专题文件" }],
      },
    };
  },
  methods: {
    zipImg() {
      if (process.env.NODE_ENV === "development") {
        this.zipUrl = process.env.VUE_APP_RESOURCE_URL + "/image/zip_icon.jpg";
      } else {
        this.zipUrl =
          window.serverConfig[window.siteMap[domain]].VUE_APP_RESOURCE_URL +
          "/image/zip_icon.jpg";
      }
    },
    handleClose(tag) {
      this.ztTags.splice(this.ztTags.indexOf(tag), 1);
      this.info.keywords = this.ztTags.join(",");
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue && inputValue.length <= 10) {
        this.ztTags.push(inputValue);
        this.info.keywords = this.ztTags.join(",");
        this.inputVisible = false;
        this.inputValue = "";
      } else if (inputValue == "") {
        this.inputVisible = false;
        this.inputValue = "";
      } else {
        this.$message({
          type: "error",
          message: "关键词最多10个字符",
        });
        return false;
      }
    },
    checkFile(e) {
      const file = e.target;
      const filePath = file.value;
      if (!filePath) return false;
      if (!/.(jpg|jpeg|png|webp)$/.test(filePath)) {
        this.$message({
          type: "error",
          message: "请选择JPG/PNG/JPEG/WEBP格式的图片",
        });
        return false;
      }
      const fileSize = file.files[0].size;
      if (fileSize / 1024 / 1024 > 2) {
        this.$message({
          type: "error",
          message: "上传的图片不能大于2M",
        });
        return false;
      }
      this.upload(file.files[0]);
    },
    async upload(file) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("code", UPLOAD_CODE.topic);
        const res = await uploadFile(UPLOAD_CODE.topic, formData);
        this.$set(this.info, "img", res.path);
        this.$set(
          this.info,
          "full_img",
          "https://" + res.full_url + "!watermark"
        );
      } catch (error) {
        this.$message({
          type: "error",
          message: error.message || "上传图片错误",
        });
      }
    },
    clearUpload() {
      this.$set(this.info, "img", "");
      this.$set(this.info, "full_img", null);
      document.querySelector("#pictureUploadFile").value = "";
    },
    checkZtFile(e) {
      if (!this.info.site_id) {
        this.$message({
          type: "error",
          message: "请先选择站点",
        });
        return false;
      }
      const file = e.target;
      const filePath = file.value;
      if (!filePath) return false;
      if (!/.(zip)$/.test(filePath)) {
        this.$message({
          type: "error",
          message: "请选择zip格式",
        });
        return false;
      }
      const fileSize = file.files[0].size;
      if (fileSize / 1024 / 1024 > 10) {
        this.$message({
          type: "error",
          message: "上传的压缩包不能大于10M",
        });
        return false;
      }
      this.uploadZhuanti(file.files[0]);
    },
    uploadZhuanti(file) {
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("link_type", this.info.link_type);
      formData.append("site_id", this.info.site_id);
      uploadZhuantiFile(UPLOAD_CODE.topic, formData)
        .then((res) => {
          this.loading = false;
          this.$set(this.info, "url", res.url);
          this.$set(this.info, "dir", res.dir);
          this.zipImg();
        })
        .catch((err) => {
          this.loading = false;
          this.zipUrl = "";
          const message = err.message;
          this.$message({
            message: message || "上传专题文件接失败",
            type: "error",
            duration: 3 * 1000,
          });
        });
    },
    clearUploadZt() {
      this.$set(this.info, "url", "");
    },
    resetForm() {
      this.$refs.formRules && this.$refs.formRules.clearValidate();
    },
    toList() {
      this.$router.push("list");
    },
    submitForm(formName) {
      this.info.keywords = this.ztTags.join(",");
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let query = this.info;
          addTopics(query)
            .then((data) => {
              this.$message({
                message: "添加成功",
                type: "success",
                duration: 3 * 1000,
              });
              this.toList();
            })
            .catch((err) => {
              this.$message({
                message: err.message || "添加失败",
                type: "error",
                duration: 3 * 1000,
              });
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.topic-loading.el-loading-parent--relative {
  position: initial !important;
}
.topic-loading /deep/ .el-loading-mask {
  top: 60px !important;
  left: 200px !important;
}
.form-group-style .form-input-item .el-tag /deep/ .el-icon-close {
  display: inline-block !important;
  border-radius: 50%;
  text-align: center;
  position: relative !important;
  cursor: pointer;
  font-size: 12px !important;
  height: 16px !important;
  width: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
  top: -1px !important;
  right: -5px !important;
}
.form-group-style .form-container .form-input-item {
  width: 40%;
}
.form-group-style {
  min-height: 600px;
  background-color: #fff;
}
.bidding-tips .form-input-item {
  width: 50% !important;
}
.huxing-input {
  display: -webkit-box;
  height: 152px;
  .el-form-item {
    -webkit-box-flex: 1;
  }
  .labels {
    font-size: 13px;
    color: #666;
    padding: 0 8px;
    display: block;
  }
  .flex-all {
    -webkit-box-flex: 1;
  }
}
.checked-labels {
  border: 1px solid #e4e7ed;
  font-size: 13px;
  color: #666;
  padding: 0px 16px;
  border-radius: 3px;
  margin: 0 15px 15px 0;
  display: inline-block;
  position: relative;
  cursor: pointer;
  .shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    transition: all 0.1s linear;
    opacity: 0;
    .el-icon-delete {
      color: #fff;
      font-size: 18px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 15px;
      height: 20px;
      display: block;
    }
  }
  &:hover {
    .shadow {
      opacity: 1;
    }
  }
}
p.tip {
  color: #666;
  margin-left: 20px;
}
.upload-group-2 {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  .el-icon-plus {
    font-size: 30px;
    color: #999;
  }
  .type-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}
.upload-group {
  .upload-item {
    width: 150px;
    height: 150px;
    position: relative;
    float: left;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: -webkit-box;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      cursor: pointer;
      transition: all 0.1s linear;
      opacity: 0;
      .el-icon-delete {
        font-size: 21px;
        color: #fff;
        display: block;
      }
    }
    &:hover {
      .shadow {
        opacity: 1;
      }
    }
    .el-icon-close {
      position: absolute;
    }
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: auto;
  margin-left: 10px;
  vertical-align: bottom;
}
#pictureUploadFile,
#pictureUploadZt {
  width: 150px;
  height: 150px;
}
</style>